import type { StateModel } from '../../models/state.model';

export const selectOfferBlobLink = (state: StateModel): string => {
    return state.offers.offerBlobLink;
};

export const selectDocumentationAPIBlobLink = (state: StateModel): string => {
    return state.offers.documentationAPIBlobLink;
};

export const selectCodexBlobLink = (state: StateModel): string => {
    return state.offers.codexBlobLink;
};

export const selectInstructionLink = (state: StateModel): string => {
    return state.offers.instructionUserManualLink;
};
